export const defaultStore = {
  isLoggedIn: false,
  reloadClient: false,
  xolasClient: {},
  org: {},
  profile: {},
  stats: {},
  statsError: false,
  debug: false,
  isChrome: null,
  isSafari: null,
  env: null,
  endpoint: null,
  hostname: null,
  copyright: null,
  windowWidth: null,
  windowHeight: null,
  // KAN-39/XOL-151: JWT auth. NOT persisted via vuex-persistedstate (we don't want two copies);
  // tokens live in localStorage, written by src/lib/auth.js.
  auth: {
    accessToken: null,
    refreshToken: null,
    claims: null,
    expiresAt: null
  }
}
